/** @format */

export const PinterestMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0146 2C6.48352 2 2 6.4725 2 11.9892C2 16.2217 4.63815 19.8367 8.36398 21.2908C8.27626 20.5 8.19774 19.2883 8.39823 18.425C8.58118 17.6442 9.57278 13.4608 9.57278 13.4608C9.57278 13.4608 9.27288 12.8608 9.27288 11.9767C9.27288 10.5908 10.0807 9.55083 11.084 9.55083C11.9394 9.55083 12.3521 10.1917 12.3521 10.9575C12.3521 11.815 11.8066 13.0967 11.5234 14.2842C11.2853 15.2783 12.0246 16.0883 13.0062 16.0883C14.7839 16.0883 16.154 14.2175 16.154 11.5158C16.154 9.13167 14.4306 7.45833 11.9703 7.45833C9.12167 7.45833 7.45174 9.59333 7.45174 11.7908C7.45174 12.6517 7.78088 13.5767 8.19439 14.075C8.2771 14.175 8.28796 14.2625 8.2654 14.3625C8.19022 14.675 8.02063 15.3617 7.98638 15.4983C7.94211 15.6858 7.8427 15.7242 7.65139 15.6358C6.40249 15.0608 5.6189 13.2375 5.6189 11.7642C5.6189 8.6175 7.91454 5.72083 12.2352 5.72083C15.7087 5.72083 18.4103 8.19333 18.4103 11.49C18.4103 14.9358 16.2325 17.7083 13.2034 17.7083C12.1892 17.7083 11.2369 17.1842 10.8994 16.5592L10.2737 18.9325C10.049 19.8033 9.43494 20.8925 9.02226 21.5542C9.9604 21.8417 10.9487 22 11.9879 22C17.5073 22 22 17.5292 22 12.0108C22 6.49167 17.5073 2.02167 11.9879 2.02167L12.0146 2Z"
                fill={color}
            />
        </svg>
    );
};
